import { GTMIcon, ManuallyIcon, ShopifyIcon } from 'tuui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { Wordpress } from '../../3p-connect/icons/Wordpress';
import { ENTITY, ENTITY_TO_PATH_MAP } from './routes';

export const trackingSetupOptions = [
    {
        id: ENTITY.GTM_SETUP,
        Icon: ({ className }) => <GTMIcon width={36} height={36} className={className} />,
        title: (
            <FormattedMessage
                id={`tracking.setup.modal.${ENTITY_TO_PATH_MAP.GTM_SETUP}.v2.label`}
                defaultMessage="Google Tag Manager"
            />
        ),
        description: (
            <FormattedMessage
                id={`tracking.setup.modal.${ENTITY_TO_PATH_MAP.GTM_SETUP}.v2.description`}
                defaultMessage="Easily install the Taboola Pixel via your GTM account—reuse your existing triggers, no code needed"
            />
        ),
        enabled: true,
        isRecommended: false,
    },
    {
        id: ENTITY.MANUALLY_SETUP,
        Icon: ({ className }) => <ManuallyIcon className={className} />,
        title: (
            <FormattedMessage
                id={`tracking.setup.modal.${ENTITY_TO_PATH_MAP.MANUALLY_SETUP}.v2.label`}
                defaultMessage="Manually install the Taboola Pixel"
            />
        ),
        description: (
            <FormattedMessage
                id={`tracking.setup.modal.${ENTITY_TO_PATH_MAP.MANUALLY_SETUP}.v2.description`}
                defaultMessage="Manually install the Taboola pixel by pasting the code in the head section of your website code."
            />
        ),
        enabled: true,
        isRecommended: false,
    },
    {
        id: ENTITY.SHOPIFY_SETUP,
        Icon: ({ className }) => <ShopifyIcon className={className} />,
        title: (
            <FormattedMessage
                id={`tracking.setup.modal.${ENTITY_TO_PATH_MAP.SHOPIFY_SETUP}.v2.label`}
                defaultMessage="Shopify"
            />
        ),
        description: (
            <FormattedMessage
                id={`tracking.setup.modal.${ENTITY_TO_PATH_MAP.SHOPIFY_SETUP}.v2.description`}
                defaultMessage="Use the official Taboola Pixel app for Shopify to easily track conversions and user actions on your store—no code needed."
            />
        ),
        visibilityCondition: ({ isShopifyEnabled }) => isShopifyEnabled,
        enabled: true,
        isRecommended: false,
    },
    {
        id: ENTITY.WORDPRESS_SETUP,
        Icon: ({ className }) => <Wordpress className={className} />,
        title: (
            <FormattedMessage
                id={`tracking.setup.modal.${ENTITY_TO_PATH_MAP.WORDPRESS_SETUP}.v2.label`}
                defaultMessage="WordPress"
            />
        ),
        description: (
            <FormattedMessage
                id={`tracking.setup.modal.${ENTITY_TO_PATH_MAP.WORDPRESS_SETUP}.v2.description`}
                defaultMessage="Use the official Taboola Pixel for WordPress plugin to quickly install the Pixel on your website—no code needed"
            />
        ),
        enabled: true,
        isRecommended: false,
    },
];
